import _ from 'lodash'
import { lazy } from 'react'
import { Navigate, RouteObject } from 'react-router-dom'
import Loadable from 'app/shared/layouts/loader/Loadable'
import { getAppMode, isRealApp } from 'app/shared/utils/comUtil'

/**
 * 개발 테스트용 페이지. TODO: 삭제
 */
import PgCalendar from 'playground/PgCalendar'
import PgInputSecure from 'playground/PgInputSecure'
import PgXlsx from 'playground/PgXlsx'
import TranskeyComponent from 'playground/transkey/TranskeyComponent'
import PgI18n from 'playground/PgI18n'
import PgTerms from 'playground/PgTerms'
import PgCommonUI from 'playground/PgCommonUI'
import PgInputRef from 'playground/PgInputRef'
import PgBanner from 'playground/PgBanner'
//---------------------------------------------------------
import Loader from 'app/shared/layouts/loader/Loader'
import { MenuDict } from 'app/core/slices/user/menu.slice'
import MAIAPP0102 from 'app/pages/mai/app/MAIAPP0102'
import PgDialogAccount from 'playground/PgAccount'
import PgValidation from 'playground/PgValidation'
import PubMain from 'pub/PubMain'
import DataFail from 'app/pages/auth/DataFail'
import ComtrueStart from 'app/pages/com/ocr/ComtrueStart'
import IdCardOCR from 'app/pages/com/ocr/idcard'
import LoadFail from 'app/pages/auth/LoadFail'
import DateConversion from 'app/pages/auth/DateConversion'
import { RetryChunkLazy } from 'app/shared/layouts/loader/RetryChunkLazy'
import TempNotice from 'app/pages/auth/TempNotice'

/** 2026.05.08 큐램 솔루션 신규 추가 */
import Quram from 'app/pages/com/ocr/Quram'

const FullLayout = Loadable(
    lazy(() => RetryChunkLazy(() => import('app/shared/layouts/FullLayout')))
)
const NotFound = Loadable(
    lazy(() => RetryChunkLazy(() => import('app/pages/auth/NotFound')))
)

const iff = (condition: boolean, then: JSX.Element, otherwise: JSX.Element) =>
    condition ? then : otherwise

const Routes = (isServiceEnabled: boolean, menuDic: MenuDict) => {
    const arrPathName = window.location.pathname.split('/')

    /**===================================================================
     * Default Routes
     =====================================================================*/
    const pgRoutes = isRealApp()
        ? []
        : [
              {
                  path: '/pg',
                  children: [
                      { path: '0', element: <PgCalendar /> },
                      { path: '1', element: <PgInputSecure /> },
                      { path: '2', element: <PgXlsx /> },
                      { path: '3', element: <PgI18n /> },
                      { path: '4', element: <PgTerms /> },
                      { path: '5', element: <PgCommonUI /> },
                      { path: '6', element: <PgInputRef /> },
                      { path: '7', element: <PgBanner /> },
                      { path: '8', element: <PgDialogAccount /> },
                      { path: '9', element: <PgValidation /> },
                      { path: 'transkey', element: <TranskeyComponent /> },
                  ],
              },
          ]
    let arrRoutes: RouteObject[] = [
        {
            path: '/',
            // element: <Navigate to="/M0000" replace={true} />,
            element: <Navigate to="/mai/app/MAIAPP0101" replace={true} />,
        },
        {
            path: '/gw',
            element: iff(
                isServiceEnabled,
                <MAIAPP0102 />,
                <Navigate to="/auth/500" replace={true} />
            ),
        },
        {
            path: '/auth',
            children: [
                { path: 'error', element: <TempNotice /> },
                { path: '404', element: <NotFound /> },
                { path: '500', element: <DataFail /> },
                { path: 'fail', element: <LoadFail /> },
                { path: 'dateConversion', element: <DateConversion /> },
            ],
        },
        {
            path: '/',
            element: iff(
                isServiceEnabled,
                <FullLayout />,
                <Navigate to="/auth/500" replace={true} />
            ),
            children: [
                {
                    path: `com/`,
                    children: [
                        {
                            path: `ocr/`,
                            children: [
                                {
                                    path: `ComtrueStart`,
                                    element: <ComtrueStart />,
                                },
                            ],
                        },
                    ],
                },
            ],
        },
		{
            path: '/',
            element: iff(
                isServiceEnabled,
                <FullLayout />,
                <Navigate to="/auth/500" replace={true} />
            ),
            children: [
                {
                    path: `com/`,
                    children: [
                        {
                            path: `ocr/`,
                            children: [
                                {
                                    path: `Quram`,
                                    element: <Quram />,
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            path: '/',
            element: iff(
                isServiceEnabled,
                <FullLayout />,
                <Navigate to="/auth/500" replace={true} />
            ),
            children: [
                {
                    path: `com/`,
                    children: [
                        {
                            path: `ocr/`,
                            children: [
                                {
                                    path: `idcard`,
                                    element: <IdCardOCR />,
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        /**  Dev only */
        ...pgRoutes,
        {
            path: '*',
            element: <Navigate to="/auth/404" replace={true} />,
        },
    ]

    /**===================================================================
     * 들어온 화면이 퍼블화면인 경우 퍼블화면만 return
     =====================================================================*/
    if (getAppMode() === 'local' || getAppMode() === 'development') {
        if (arrPathName.length > 1 && arrPathName[1] === 'pub') {
            const mainComponent = <PubMain />
            let pubList = []

            if (arrPathName.length > 2) {
                let path = ''

                for (let i = 2; i < arrPathName.length; i++) {
                    if (i === arrPathName.length - 1) {
                        const pathName = arrPathName[i]
                        path +=
                            _.toUpper(pathName.at(0)) +
                            pathName.substring(1, pathName.length)
                    } else {
                        path += arrPathName[i] + '/'
                    }
                }

                const PubPage = Loadable(
                    lazy(() =>
                        RetryChunkLazy(() => import('pub/pages/' + path))
                    )
                )

                pubList = [{ path: `/pub/${path}`, element: <PubPage /> }]
            }

            let pubRoute = {
                path: '/pub',
                element: mainComponent,
            }

            return [...arrRoutes, pubRoute, ...pubList]
        }
    }

    /**===================================================================
     * isServiceEnabled 서비스불가 > DataFail
     =====================================================================*/

    if (!isServiceEnabled) {
        return [
            {
                path: '*',
                element: <Navigate to="/auth/500" replace={true} />,
            },
        ]
    }

    if (!menuDic) {
        //메뉴정보 없는 경우 로더페이지 보여줌
        return [
            {
                path: '*',
                element: <Loader />,
            },
        ]
    }

    /**===================================================================
     * 1. 이동하려는 URL 
     =====================================================================*/
    arrPathName.shift()

    // 1-1 메뉴 ID로 들어오는 경우 CHECK 해서 이동
    // ex) https://domain.com/M0040
    const menuId = [...arrPathName][0]
    if (menuId in menuDic) {
        const newPath = menuDic[menuId].menuUrlAdr
            .replace('/', '')
            .replace('.tsx', '')
        return [
            {
                path: '*',
                element: (
                    <Navigate
                        to={newPath}
                        replace={true}
                        state={window.history.state['usr']}
                    />
                ),
            },
        ]
    }

    // 1-2 실제 PATH 경로
    // ex) https://domain.com/prd/man/PRDMAN0101

    const path = arrPathName.join('/')

    const SubPage = lazy(() =>
        RetryChunkLazy(() => import('app/pages/' + path))
    )

    let targetRoute: RouteObject[] = []
    if (arrPathName.length === 3 && arrPathName[0] != 'pub') {
        targetRoute = [
            {
                path: '/',
                element: iff(
                    isServiceEnabled,
                    <FullLayout />,
                    <Navigate to="/auth/500" replace={true} />
                ),
                children: [
                    {
                        path: `${arrPathName[0]}/${arrPathName[1]}/${arrPathName[2]}`,
                        element: <SubPage />,
                    },
                ],
            },
        ]
    }

    return [...arrRoutes, ...targetRoute]
}

export default Routes
